<div class="list-container" *ngFor="let reindex of reindexes">
  <sh-reindex-table-item class="list-item" [reindex]="reindex"
                         (onRedirectToLogs)="ViewReindexLogs($event)"
                          (onRetry)="retryReindex($event)"></sh-reindex-table-item>
</div>
